// Suppressed songs: the ones whose text we refuse to render.
//
// SINGLE SOURCE OF TRUTH IS data/suppressions.json, mirrored from the Firebase
// `suppressions` node. postbuild reads it, renders the user-facing sentence into
// the prerendered HTML, then inlines that SAME string here as window.__SUP__.
// So the string React renders is byte-identical to the one already on screen,
// which is what keeps a suppressed song from flashing lyrics or flickering.
//
// Consequence, and the point of the exercise: taking a song down is a one-line
// data edit plus `npm run seo`. No code change here, and no React rebuild.
//   t: "d" = delisted  (hide the song everywhere)
//   t: "c" = copyright (keep it listed, never render the text)
export type Suppression = { t: "d" | "c"; s: string };

const MAP: Record<string, Suppression> =
  (typeof window !== "undefined" &&
    (window as unknown as { __SUP__?: Record<string, Suppression> }).__SUP__) ||
  {};

export const isDelisted = (id: string | number): boolean =>
  MAP[String(id)]?.t === "d";

export const isSuppressed = (id: string | number): boolean =>
  Boolean(MAP[String(id)]);

/** The sentence shown in place of the lyrics. Empty when the song is fine. */
export const suppressionSentence = (id: string | number): string =>
  MAP[String(id)]?.s || "";

export const delistedIds = (): string[] =>
  Object.keys(MAP).filter((id) => MAP[id].t === "d");

export const suppressedIds = (): string[] => Object.keys(MAP);
